module.exports = require("immutable");


//////////////////
// WEBPACK FOOTER
// external "immutable"
// module id = 1
// module chunks = 0